import { PrintOptionsVisibility } from '../types/print-options-visibility.type';

export const PRINT_OPTIONS_SWISS_VISIBILITY: PrintOptionsVisibility = {
    consistencyCheck: {
        showDetails: true,
        isExpanded: false,
    },
    styleOptions: {
        textColor: true,
        titleColor: true,
        backgroundColor: true,
    },
    displayOptions: {
        hasCompanyInfosToggle: true,
        hasAccountsToggle: true,
        hasCoverSheetToggle: true,
        hasCompanyLogoToggle: true,
        hasUIDonCoverToggle: true,
        hasTableOfContentsToggle: true,
        hasDisableBalanceSheetPageBreakToggle: true,
        hasHideDecimalPlacesToggle: true,
        hasHideEmptyLinesToggle: true,
        hasHidePreviousYearToggle: true,
        hasFliTotalToggle: true,
        hasGroupHeadersToggle: false,
        hasGroupTotalsToggle: false,
        hasFcpToggle: true,
        hasAopToggle: false,
        hasCfsToggle: false,
        hasNotesToggle: false,
        hasComplementaryReportsToggle: false,
        hasEmsToggle: false,
        hasFasToggle: false,
        hasPrintInGrayscaleToggle: true,
        hasCustomPageNumbersToggle: true,
        hasReClassInSumsToggle: true,
        hasAdjustmentInSumsToggle: true,
        hasRatiosToggle: true,
        hasShareholderInformationToggle: false,
        hasAccountNumbersToggle: true,
        hasAccountProofForBalanceToggle: false,
        hasAccountProofForIncomeToggle: false,
        hasExperimentalOptions: true,
        hasAopHideDecimalPlacesValuesToggle: true,
        hasAopHideDecimalPlacesRatiosToggle: true,
        hasAopHideEmptyLinesToggle: false,
        hasNotesHideDecimalPlacesValuesToggle: true,
        hasNotesHideDecimalPlacesRatiosToggle: true,
        hasNotesHideEmptyLinesToggle: false,
        hasFinStatementHideDecimalPlacesValuesToggle: true,
        hasFinStatementHideDecimalPlacesRatiosToggle: true,
        hasFinStatementHideEmptyLinesToggle: false,
        hasFinStatementRoundToThousandsToggle: true,
        hasNotesRoundToThousandsToggle: true,
        hasAopRoundToThousandsToggle: true,
        hasPrintExportButtons: true,
        hasNonBreakingHyphenToggle: true,
        hasApplyGroupingMaskingToggle: true,
        hasRepeatAppendixTitleToggle: true,
    },
    signatureOptions: {
        hasSignature: true,
        isCollectiveSignature: true,
        placeSignatureAfterAop: false,
    },
};
